
import React from 'react';
import './App.css';
import PageHeader from './components/PageHeader/PageHeader';
import Footer from './components/Footer/Footer';
import i18n from './i18n';
import ContentBox from './components/ContentBox/ContentBox';
import MapComponent from './components/MapComponent/MapComponent';
import {reactLocalStorage} from 'reactjs-localstorage';
import parse from 'html-react-parser';
import { withTranslation } from 'react-i18next';
import MembersListItem from './components/MembersListItem/MembersListItem';

class App extends React.Component{

  constructor(props) {
      super(props);
      const t = i18n.t;
      this.state = { t, i18n, ln: 'sr' };
      console.log(this.state);
  }

  changeLanguage(ln) {
      this.state.i18n.changeLanguage(ln);
      this.setState({ ln });
      reactLocalStorage.set('language', ln);
  }

  componentDidMount() {
      const ln = reactLocalStorage.get('language', null, true);
      this.state.i18n.changeLanguage(ln || 'sr');
      this.setState({ ln });
  }
  render(){
    const { t, i18n } = this.state;
    return (
      <div className="main-page-wrap">
        <PageHeader i18n={i18n} t={t} changeLanguage={this.changeLanguage.bind(this)}></PageHeader>
        <ContentBox id='name' title={parse(i18n.t('headings.namebased'))} src={require("./assets/images/02_malina.jpg").default}>
          <p className='cb-p'>{parse(i18n.t('content.namebased.p1'))}</p>
          <p className='cb-p'>{parse(i18n.t('content.namebased.p2'))}</p>
          <p className='cb-p'>{parse(i18n.t('content.namebased.p3'))}</p>
          <iframe className='iframe-video' title='visnje' src="https://www.youtube.com/embed/90ei-Oo8xOw" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen="allowfullscreen" webkitallowfullscreen='webkitallowfullscreen' mozallowfullscreen='mozallowfullscreen'></iframe>
        </ContentBox>
        <ContentBox id='story' title={parse(i18n.t('headings.about'))} src={require("./assets/images/03_malina.jpg").default}>
          <div className='small-cb'>
            <h4 className='black-roboto'><b>{parse(i18n.t('content.about.subheadings.area'))}</b></h4>
            <p className='cb-p'>{parse(i18n.t('content.about.paragraphs.area'))}</p>
          </div>
          <div className='small-cb'>
            <h4 className='black-roboto'><b>{parse(i18n.t('content.about.subheadings.history'))}</b></h4>
            <p className='cb-p'>{parse(i18n.t('content.about.paragraphs.history1'))}</p>
            <p className='cb-p'>{parse(i18n.t('content.about.paragraphs.history2'))}</p>
          </div>
          <div className='small-cb'>
            <h4 className='black-roboto'><b>{parse(i18n.t('content.about.subheadings.characteristics'))}</b></h4>
            <p className='cb-p'>{parse(i18n.t('content.about.paragraphs.characteristics'))}</p>
          </div>
        </ContentBox>
        <ContentBox id='association' title={parse(i18n.t('headings.association'))} src={require("./assets/images/04_malina.jpg").default}>
          <p className='cb-p'>{parse(i18n.t('content.association.p1'))}</p>
          <p className='cb-p'>{parse(i18n.t('content.association.p2'))}</p>
          <p className='cb-p'>{parse(i18n.t('content.association.p3'))}</p>
        </ContentBox>
        <ContentBox id='members' title={parse(i18n.t('headings.members'))} src="">
          <MembersListItem name="Drenovac doo" link="https://www.drenovac.co.rs" address="Mirosaljci bb 31230 Arilje" description={i18n.t('content.members.drenovac.text')}/>
          <MembersListItem name="Frigo Junior doo " link="https://www.frigojunior.rs" address="Vigošte bb 31230 Arilje" description={i18n.t('content.members.frigo.text')}/>
          {/* <MembersListItem name="DBA Promet doo" link="https://www.dba-promet.com" address="Cerova bb 31230 Arilje" description="Skoro deceniju i po, preduzeće koje se bavi proizvodnjom, otkupom i preradom voća smešteno je u selu Cerova kraj Arilja." /> */}
          <MembersListItem name="OZZ Agro Eko Voće" link="" address="Boška Buhe bb 31230 Arilje" description={i18n.t('content.members.ozzagro.text')}/>
          <MembersListItem className='last-member' name="Nectar doo" link="https://www.nectar.rs" address="Ive Lole Ribara bb 31230 Arilje" description={i18n.t('content.members.nectar.text')} />
          <MapComponent/>
        </ContentBox>
        <ContentBox id='contact' className='last-cb' title={parse(i18n.t('headings.contact'))} src="">
          <p className='cb-p small-line'>{parse(i18n.t('content.contact.name'))}</p>
          <p className='cb-p small-line'>{parse(i18n.t('content.contact.address'))}</p>
          <p className='cb-p small-line'>{parse(i18n.t('content.contact.city'))}</p>
          <hr className="small-hr"/>
          <p className='cb-p small-line'>{parse(i18n.t('content.contact.number1'))}</p>
          <p className='cb-p small-line'>{parse(i18n.t('content.contact.number2'))}</p>
          <p className='cb-p small-line'>{parse(i18n.t('content.contact.city'))}</p>
          <p className='cb-p small-line'><a href="mailto:info@ariljskamalina.rs">{i18n.t('content.contact.email')}</a></p>
        </ContentBox>
    
        <Footer footertext={parse(i18n.t('footer.footertext'))} src={require("./assets/images/05_malina.jpg").default}/>
      </div>
    )
  }
}

export default withTranslation()(App);
